<!-- BEGIN HEADER -->
<div class="header">
  <app-notify-message></app-notify-message>
  <!-- BEGIN NAVBAR -->
  <nav id="header" class="navbar navbar-expand-lg navbar--bold navbar-light bg-default navbar--bb-1px">
    <!--navbar-inverse bg-dark-->
    <div class="row width100 menuHeightFix">
      <!-- BEGIN LOGO -->
      <div class="menuLogo">
        <a class="navbar-brand" (click)="redirectTo()">
          <img  style="height: 45px;"
            src="../../../assets/img/CleverCharge logo.png"
            />
          </a>
        </div>
        <!--END LOGO-->
        <div class="d-inline-block noDis mt-2">
          <!-- BEGIN NAVBAR TOGGLER  -->
          <button class="navbar-toggler hamburger-js hamburger--spring border-0"
            type="button" data-toggle="collapse" data-target="#navbar_main">
            <span #menuClose class="hamburger-box">
              <!-- <span class="hamburger-inner"></span> -->
              <img src="../../../assets/img/bitbrew_menu.png" width="24" height="24">
            </span>
          </button>
          <!-- END NAVBAR TOGGLER  -->
        </div>
        <div class="collapse navbar-collapse align-items-center justify-content-end" id="navbar_main">
          <ul class="navbar-nav">
            <!-- <li *ngIf="localImpersonate=='true'" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <form (ngSubmit)="f.form.valid && stopImpersonate()" #f="ngForm" novalidate class="search-box mt-2 mr-2">
              <div class="container-input">
                <button class="btn btn-peak m-0">Stop Impersonate</button>
              </div>
            </form>
          </li> -->
          <!-- Outer header Items -->
          @for (header of outerHeader; track header) {
            <li class="nav-item" routerLinkActive="active"
              [ngClass]="{'active-report':window.location.pathname==defaultReportUrl.getItem('lastReportUrl')&&header.permission=='REPORT'}">
              @if (
                header.permission!=='REPORT' &&
                header.permission!=='ADMIN' &&
                header.permission!=='TOOLS' &&
                header.permission!=='DASHBOARD' &&
                header.permission!=='DATA' &&
                header.permission!=='HISTORY' &&
                header.permission!=='DEVICE' &&
                header.permission!=='OTA' &&
                header.permission!=='DESTINATIONS' &&
                header.permission!=='DATAHUB' &&
                header.permission!=='HOME' &&
                !(header.permission==='SUPPORT' && isSupportUser && isSupportViewMode()) &&
                !(header.permission==='OVERVIEW' && isSupportUser && isSupportViewMode())
                ) {
                <a class="nav-link ripple"
                  [routerLink]="header.route"
                  (click)="[subNavHeader('')]"
                  >
                  <i class="fa fa-{{header.icon}} p-0 m-0"></i>
                  {{ header.name | translate }}
                </a>
              }
              <!-- Special case header for dynamic routing -->
              @if (header.permission==='REPORT') {
                <a
                  [routerLink]="defaultReportUrl.getItem('lastReportUrl')"
              [class.active]="
                router.isActive('/score', true) ||
                router.isActive('/reports/device/alPlantMode', true) ||
                router.isActive('/reports/device/device-report', true) ||
                router.isActive('/reports/system/not-communicating', true) ||
                router.isActive('/reports/system/version-drilldown', true) ||
                router.isActive('/reports/system/provisioning', true) ||
                router.isActive('/reports/device/usage', true) ||
                router.isActive('/reports/deep-view', true) ||
                router.isActive('/reports/score', true)
              " class="nav-link ripple" (click)="menuClick(); subNavHeader('')">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{header.name | translate}}
            </a>
            }
            <!-- Header with sub routing -->
            <!-- For Admin Header -->
            @if (header.permission==='ADMIN') {
            <a class="nav-link ripple" (click)="menuClick(); subNavHeader('')" [class.active]="
                router.isActive('/admin/users', true) ||
                router.isActive('/admin/roles', true) ||
                router.isActive('/admin/place', true) ||
                router.isActive('/admin/alerts', true) ||
                router.isActive('/admin/alerts/create-alert', true) ||
                router.isActive('/admin/whitelabel', false) ||
                router.isActive('/admin/developer', false) ||
                router.isActive('/admin/destination', false) ||
                router.isActive('/admin/rules', true) ||
                router.isActive('/admin/audit-trial', true) ||
                router.isActive('/marketplace', true)
              " [routerLink]="header.route">
              <i class="fa-regular fa-{{header.icon}} p-0 m-0"></i>
              {{header.name | translate}}
            </a>
            }
            <!-- history tab header -->
            @if (header.permission==='HISTORY') {
            <a class="nav-link ripple" (click)="subNavHeader('HISTORY')"
              [class.active]="router.isActive('/location-history', false) || router.isActive('/trips', false)"
              [routerLink]="header.route">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{ header.name | translate }}
            </a>
            }
            @if (header.permission === 'DEVICE') {
            <a class="nav-link ripple" (click)="subNavHeader('');"
              [class.active]="(productType === 'EVSE' || productType === 'VIM') ? router.isActive('/v2/devices', false) : router.isActive('/devices', false)"
              [routerLink]="header.route">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{ header.name | translate }}
            </a>
            }
            @if (header.permission === 'OTA') {
            <a class="nav-link ripple" (click)="subNavHeader('');"
              [class.active]="(productType === 'EVSE' || productType === 'VIM') ? router.isActive('/v2/ota', false) : router.isActive('/ota', false)"
              [routerLink]="header.route">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{ header.name | translate }}
            </a>
            }
            @if (header.permission === 'DESTINATIONS') {
            <a class="nav-link ripple" (click)="subNavHeader('');"
              [class.active]="router.isActive('/destinations', false)"
              [routerLink]="header.route">
              <i class="fa-solid fa-database p-0 m-0"></i>
              {{ header.name | translate }}
            </a>
            }
            <!-- For Tools Header -->
            @if (header.permission==='TOOLS') {
            <a class="nav-link ripple" (click)="subNavHeader('')" [routerLink]="header.route" [class.active]="
                router.isActive('/tools/cache', true) ||
                router.isActive('/tools/republish', true)
              ">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{header.name | translate}}
            </a>
            }
            <!-- Home Header -->
            @if (header.permission==='HOME' && !(isSupportUser && !isSupportViewMode())) {
            <a class="nav-link ripple" (click)="menuClick(); subNavHeader('')" [routerLink]="header.route"
              [class.active]="router.isActive('/chargers', true) || router.isActive('/vehicles', true)">
              <i class="fa fa-{{header.icon}} p-0 m-0"></i>
              {{header.name}}
            </a>
            }

            <!-- For Dashboard Header -->
            @if (header.permission==='DASHBOARD' && !(isSupportUser && !isSupportViewMode())) {
            <a class="nav-link ripple" (click)="subNavHeader('')" [routerLink]="header.route">
              <i class="fa fa-bug p-0 m-0"></i>
              <!-- {{header.name | translate}} -->
              <span class="ml-1">Debug Logs</span>
            </a>
            }

          </li>
          }
          <!-- Dropdown header Items -->
          @if (dropdownHeader.length) {
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"
                id="dropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                href="javascript:void(0)"
                data-hover="dropdown">
                More
                <i class="fa fa-angle-down mr-0"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right dropdown-scale" aria-labelledby="dropdownMenuButton">
                @for (header of dropdownHeader; track header) {
                  <span>
                    @if (
                      header.permission!=='ADMIN' &&
                      header.permission!=='TOOLS'
                      ) {
                      <a class="dropdown-item"
                        (click)="menuClick();"
                        routerLinkActive="active"
                        [routerLink]="header.route"
                        >
                        <i class="fa fa-{{header.icon}}"></i>
                        {{header.name | translate}}
                      </a>
                    }
                    <!-- Header with sub routing -->
                    <!-- For Admin Header -->
                    @if (header.permission==='ADMIN') {
                      <a
                        class="dropdown-item"
                        (click)="menuClick();"
                        [routerLink]="header.route"
                  [class.active]="
                    router.isActive('/admin/users', true) ||
                    router.isActive('/admin/roles', true) ||
                    router.isActive('/admin/place', true) ||
                    router.isActive('/admin/alerts', true) ||
                    router.isActive('/admin/alerts/create-alert', true) ||
                    router.isActive('/admin/whitelabel', false) ||
                    router.isActive('/admin/developer', false) ||
                    router.isActive('/admin/destination', false) ||
                    router.isActive('/admin/rules', true) ||
                    router.isActive('/admin/audit-trial', true)
                  ">
                        <i class="fa fa-{{header.icon}}"></i>
                        {{header.name | translate}}
                      </a>
                    }
                    <!-- For Tools Header -->
                    @if (header.permission==='TOOLS') {
                      <a
                        class="dropdown-item"
                        (click)="menuClick();"
                        [routerLink]="header.route"
                  [class.active]="
                    router.isActive('/tools/cache', true) ||
                    router.isActive('/tools/republish', true)
                  ">
                        <i class="fa fa-{{header.icon}}"></i>
                        {{header.name | translate}}
                      </a>
                    }
                  </span>
                }
              </div>
            </li>
          }


<!--help icon-->
<!-- <li class="nav-item relative" routerLinkActive="active">
<a class="nav-link ripple" href="https://developer.drivewithdarby.com" target="_blank">
  <i class="fa fa-question-circle-o p-0 m-0" style="font-size: 16px;"></i>
</a>
</li> -->
<!-- <li class="dashboard-dropdown dropdown nav-item">
  <a class="dropdown-toggle nav-link has-badge ripple pdlr-2" id="dropdownMenuButton" href="javascript:void(0)"
    data-toggle="dropdown" aria-haspopup="true" data-hover="dropdown" aria-expanded="false">
    <span class="dropdown-text ">
      <i class="fa fa-lg fa-question-circle-o p-0 m-0"></i>
    </span>
  </a>
  <div class="dropdown-menu dropdown-menu-right dropdown-scale" aria-labelledby="dropdownMenuButton">
    <a href="https://docs.bitbrew.com" target="_blanks" class="dropdown-item ripple">
      Documentation
    </a>
    //<div class="dropdown-divider" role="presentation"></div>
    <a href="mailto:help@bitbrew.com" target="_blanks" class="dropdown-item ripple">
      Help
    </a>
    <a href="https://status.bitbrew.com" target="_blanks" class="dropdown-item ripple">
      Health
    </a>
  </div>
</li> -->
<!-- profile dropdown div starts -->
<li class="dashboard-dropdown dropdown nav-item ml-md-2">
  <a class="dropdown-toggle nav-link has-badge ripple text-center"
    [routerLink]="'/profile'"
              [class.active]="
                router.isActive('/profile', true)
              "
    id="dropdownMenuButton" href="javascript:void(0)"
    data-toggle="dropdown" aria-haspopup="true"
    data-hover="dropdown" aria-expanded="false">
    <span class="dropdown-text strong-600">
      <img id="headerProfilePic" class="rounded-circle profile-pic" alt=""
        [src]="profilePicSafeUrl"
        onerror="this.src='../../../../assets/img/user.png'">
        {{currentUser?.firstName}}
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-scale" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item ripple" (click)="menuClick(); subNavHeader('');" routerLink="/profile" href="javascript:void(0)">
        <i class="fa fa-user darbyColor"></i>Profile
      </a>
      <!--<div class="dropdown-divider" role="presentation"></div>-->
      <a class="dropdown-item" style="cursor : pointer" (click)="logout()">
        <i class="fa fa-power-off darbyColor"></i>Logoff
      </a>
    </div>
  </li>
  <!-- profile dropdown div ends -->
  <!-- Stop Impersonate Button -->
  @if (localImpersonate=='true' || isSupportViewMode()) {
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <form (ngSubmit)="f.form.valid && stopImpersonate()" #f="ngForm" novalidate class="search-box impersonate-btn">
        <div class="container-input">
          <button [ngbTooltip]="isSupportViewMode() ? 'Stop Viewing Customer' : 'Stop Impersonating.'" class="btn btn-peak btn-sm m-0">Stop</button>
        </div>
      </form>
    </li>
  }
  <!-- Stop Impersonate end -->
</ul>
</div>
</div>
</nav>





@if (notifications.length && alertMessage) {
  <div class="notification-container">
    <div [id]="notifications[0].type"
      class="alert alert-success alert-dismissible fade show notification-banner row justify-content-md-center"
      role="alert">
      <p class="mb-0 col-12 col-lg-3 heading">{{notifications[0].title}}</p>
      <p class="mb-0 col-12 col-lg-7 content">{{notifications[0].body}}</p>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"
        (click)="closeUserNotification(notifications[0].userNotificationId)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
}
</div>
